import React from 'react';
import { useTranslation } from '@blocs.i18n';
import { ConfirmationModal } from '@minecraft.organisms';

type UnifiedReconnectModalProps = {
  close: () => void;
  onReconnect: () => void;
  platform: 'Instagram' | 'YouTube';
};

const PLATFORM_ICON_MAP = {
  Instagram: 'profile-social-instagram',
  YouTube: 'profile-social-youtube',
} as const;

export const UnifiedReconnectModal = ({ close, onReconnect, platform }: UnifiedReconnectModalProps) => {
  const { t } = useTranslation();

  return (
    <ConfirmationModal
      isOpen
      close={close}
      onSubmit={onReconnect}
      icon={PLATFORM_ICON_MAP[platform]}
      header={t('common:profileEdit.social.reconnectModal.header', { socialMediaPlatform: platform })}
      descriptionLineOne={t(`common:profileEdit.social.${platform.toLowerCase()}.reconnectModal.description1`)}
      descriptionLineTwo={t(`common:profileEdit.social.${platform.toLowerCase()}.reconnectModal.description2`)}
      cancelLabel={t('common:button.notNow')}
      submitLabel={t('common:button.reconnectNow')}
      dataTestId={`${platform.toLowerCase()}-reconnect`}
    />
  );
};
